module.exports = "请使用终端命令行，在项目根目录中运行以下命令：\n\n`taro info`\n\n并将运行结果复制粘贴到上面的输入框中。\n"